import { render, staticRenderFns } from "./KnownMethodAdd.vue?vue&type=template&id=5a2ca05c&"
import script from "./KnownMethodAdd.vue?vue&type=script&lang=js&"
export * from "./KnownMethodAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports